import { useTenantBranding } from '@/hooks/use-tenant-branding';

const APP_VERSION = import.meta.env.PACKAGE_VERSION;

export function Footer() {
  const { brandName } = useTenantBranding();

  return (
    <footer className="flex h-10 shrink-0 items-center justify-between border-t border-border bg-background px-6 text-xs text-muted-foreground">
      <span className="truncate">{brandName}</span>
      <span className="shrink-0">v{APP_VERSION}</span>
    </footer>
  );
}
